/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiCustomThemeFromJSON(json) {
    return StreemApiCustomThemeFromJSONTyped(json, false);
}
export function StreemApiCustomThemeFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'primaryColor': !exists(json, 'primary_color') ? undefined : json['primary_color'],
    };
}
export function StreemApiCustomThemeToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'primary_color': value.primaryColor,
    };
}
//# sourceMappingURL=StreemApiCustomTheme.js.map